type PlansTextProps = {
  svg?: any;
  text: string;
};
const PlansText = ({ svg, text }: PlansTextProps) => {
  return (
    <div className="flex items-center gap-5 [&>svg]:scale-110">
      {svg}
      <span className="w-[80%] text-subColor3 text-[15px]">{text}</span>
    </div>
  );
};

export default PlansText;
